import "./expired.scss";
import {
    type FC,
    type ReactNode,
    useEffect,
    useState,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../Common/Buttons/Button";
import { usePermissions } from "../../Utilities/Domain/Users/Permissions";

const requiredPermissions = [ "manage_billing" ] as const;

const Expired: FC = () => {
    const navigate = useNavigate();
    const [ onIce, setOnIce ] = useState(() => {
        return window.location.search.includes("ice=true");
    });

    useEffect(() => {
        const checkExpiry = () => {
            // query={viewer{id}}
            fetch("/graphql?query=%7Bviewer%7Bid%7D%7D", {
                method : "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept"      : "application/json",
                },
            })
                .then(async response => {
                    if(!response.ok) {
                        // Error other than expired error code
                        if(response.status !== 402 && response.status !== 401) {
                            throw await response.json();
                        }
                    }

                    return response.json();
                })
                .then(body => {
                    // Check if data is returned
                    if(body.data || body.error === "Unauthenticated.") {
                        navigate("/");
                    } else {
                        setOnIce(body.onIce === true);
                    }
                })
                .catch(err => {
                    console.error("Received error while checking if we're still expired", err);
                });
        };

        checkExpiry();

        const interval = setInterval(
            checkExpiry,
            2 * 60 * 1000
        );

        return () => {
            clearInterval(interval);
        };
    }, [ navigate ]);

    const { manageBilling } = usePermissions(requiredPermissions);
    let message: ReactNode = "Please contact us to continue.";
    let basicMessage = "Your Vendor has expired.";

    if(onIce) {
        basicMessage = "Your Vendor is on ice. Your data is saved on Shopfront's servers but you don't have " +
            "access to it.";
    }

    let action: ReactNode = null;

    if(manageBilling) {
        if(onIce) {
            message = (
                <>
                    To access your data,{" "}
                    <Link to="/settings/account?expired">
                        subscribe to one of our plans and make sure your payment details are setup correctly
                    </Link>.
                </>
            );
        } else {
            message = (
                <>
                    Make sure your <Link to="/settings/account?expired">Payment Details</Link> are <br />
                    setup correctly or contact us to continue.
                </>
            );
        }

        action = (
            <Link to="/settings/account?expired">
                <Button classes={[ "button-primary shadow px-4" ]}>
                    Update Payment Details
                </Button>
            </Link>
        );
    }

    return (
        <div id="expired">
            <img src="/imgs/logo.png" id="shopfront-logo" title="Shopfront" alt="Shopfront" />
            <div id="error-message">
                <p id="main-message" className="max-w-4xl">{basicMessage}</p>
                <p className="max-w-4xl text-2xl">{message}</p>
                {action !== null && (
                    <div className="max-w-4xl mt-8 text-2xl">
                        {action}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Expired;
